<template>
  <gj-modal
      size="normal"
      :visible.sync="modalVisible"
  >
    <template #header>导入日期范围报告</template>
    <template #content>
      <div
          v-loading="loading"
          element-loading-text="文件上传成功，正在验证导入文件验证"
          element-loading-spinner="el-icon-loading"
      >
        <div>
          <el-row>
            <el-col :span="12">
              <span style="color: #999; margin-right: 10px"><gj-required></gj-required> 店铺/国家</span>
              <gj-market-select
                  style="margin-right: 10px;"
                  v-model="marketId"
                  width="120px"
                  :clearable="false"
              ></gj-market-select>
            </el-col>
            <el-col :span="12">
              <span style="color: #999; margin-right: 10px"><gj-required></gj-required>报表类型</span>
              <gj-select
                  v-model="reportType"
                  placeholder="报表类型"
                  :options="orderTypeOption"
                  width="120px"
                  :clearable="false"
              ></gj-select>
            </el-col>
          </el-row>
        </div>
        <div class="gj-mb10" style="margin-top: 10px;">
          <gj-upload
              class="upload-btn"
              :disabled="marketId === null || reportType === null"
              containerType="profitSettlement"
              @uploadAfter="uploadAfter"
              :valid-file-size="200"
              :acceptType="[FileTypeEnum.CSV, FileTypeEnum.X_CSV, FileTypeEnum.XLS, FileTypeEnum.XLSX, FileTypeEnum.X_XLS]"
          >
            <template #tip>
              <span>只能上传csv/xls文件</span>
            </template>
          </gj-upload>
        </div>
        <gj-import-alert
            :rules="[
            '导入需要指定站点',
            '导入数据必须是原文件CSV/XLS格式',
            '导入的文件不能超过200M',
          ]">
        </gj-import-alert>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../minxins";
  import {orderTypeOption} from "../../../../../../utils/options";
  import {importRangeReport} from "../../../../../../api/finance";
  import {mapGetters} from "vuex";
  import {FileTypeEnum} from "../../../../../../components/upload/enum";

  export default {
    name: "settlement-import",
    mixins: [modalMixIn],
    computed: {
      ...mapGetters({
        marketMap: 'marketMap',
      })
    },
    data() {
      return {
        marketId: null,
        reportType: null,
        orderTypeOption: orderTypeOption,
        loading: false,
        FileTypeEnum: FileTypeEnum,
      }
    },
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.loading = true;
        importRangeReport({
          attachmentId: attId,
          countryCode: this.marketMap[this.marketId].countryCode,
          marketId: this.marketId,
          orderType: this.reportType
        })
          .then(res => {
            if (res.code !== 0) {
              this.$gjMessage.error(res.msg);
            } else {
              this.$gjMessage.success('导入成功！正在后台更新数据，请稍等');
              uploadCb(res)
              this.$emit('importSuccess');
            }
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.loading = false);
      },
    }
  }
</script>

<style scoped>

</style>
